import { connect } from "react-redux";
import ImportForm from "./import_form";
import { change } from "redux-form";
import { withRouter } from "react-router";
import { searchDirectoryShows } from "../../../actions/directory_shows";
import { submitEpisodesFeedImport, submitShowFeedImport } from "../../../actions/feed_import";
import get from "lodash/get";
import DefaultActionManager from "../../../action_managers/default_action_manager";
import { USER_IMPORT_JOB } from "../../../actions/user";
import { CATEGORIES, ACTIONS, gtagEvent } from "../../../lib/google_analytics";
import { distribute } from "../../../action_managers/distributions";
import { distributionKeyNames } from "../../../constants/distribution";

function mapStateToProps(state) {
  return {
    user: state.user.user,
    searchResults: state.directoryShows.results,
    isLoading: state.showFeedImport.isLoading || state.episodeFeedImport.isLoading,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    searchDirectoryShows: (query, user) => {
      gtagEvent(ACTIONS.SEARCH, CATEGORIES.DIRECTORY_SHOWS);
      return dispatch(searchDirectoryShows(query, user));
    },
    setFeedURL: url => {
      dispatch(change("feed-import", "feedURL", url));
    },
    feedImport: (url, bitrate) => {
      return dispatch(submitShowFeedImport(url)).then(response => {
        var showUUID = get(response, "json.uuid");
        if (showUUID) {
          return dispatch(submitEpisodesFeedImport(showUUID, url, bitrate))
            .then(() => {
              return dispatch(
                distribute(showUUID, [
                  distributionKeyNames.googlePodcasts,
                  distributionKeyNames.radioPublic,
                ])
              );
            })
            .then(() => {
              return {
                ...response,
                showUUID,
              };
            });
        }
        return Promise.resolve({});
      });
    },
    fetchJobsForUser: user => {
      dispatch(
        new DefaultActionManager({
          auth: true,
          route: `users/${user.uuid}/import-jobs`,
          actionName: USER_IMPORT_JOB,
        }).run()
      );
    },
  };
}

const ImportFormWrapper = withRouter(connect(mapStateToProps, mapDispatchToProps)(ImportForm));

export default ImportFormWrapper;
